import { useEffect, useState } from 'react'
import { isMobileOnly } from 'react-device-detect'
import { useDispatch } from 'react-redux'

import { elsewhereKeys, elsewhereEventEmitter } from 'helpers/events'
import { isObjectEmpty } from 'helpers/object'

const useElsewhereMsgHandler = identity => {
    const dispatch = useDispatch()
    const [isAway, setIsAway] = useState(false)

    useEffect(() => {
        const handleElsewhereMsg = elsewhereMsg => {
            if (isObjectEmpty(elsewhereMsg) || isMobileOnly) return
            const { key, sender } = elsewhereMsg
            if (sender !== identity.uuid) return
            setIsAway(key === elsewhereKeys.USER_IS_AWAY)
        }

        elsewhereEventEmitter.addListener(
            elsewhereKeys.ELSEWHERE,
            handleElsewhereMsg
        )

        return () => {
            elsewhereEventEmitter.removeListener(
                elsewhereKeys.ELSEWHERE,
                handleElsewhereMsg
            )
        }
    }, [dispatch, identity.uuid])

    return { isAway }
}

export default useElsewhereMsgHandler
